<template>
  <v-dialog
      scrollable
      v-model="visable"
      max-width="700px"
      :persistent="true"
  >
    <v-card>
      <v-card-title class="subheading">
        {{ loading ? '评审开始…': '确认开始评审？' }}
      </v-card-title>

      <v-divider></v-divider>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <p class="subheading">{{ message }}</p>
        <div>

          <v-form v-model="formStartValid" ref="formRef" lazy-validation>
            <v-container grid-list-md>
              <v-layout wrap>

                <v-flex sm6>
                  <v-menu
                      ref="refReceiveStartDate"
                      :close-on-content-click="false"
                      v-model="menuReviewStartDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="item.startDate"
                        label="评审开始日期"
                        :rules="rules.startDate"
                        hint="格式YYYY-MM-DD"
                        persistent-hint
                    />
                    <v-date-picker
                        v-model="reviewStartDate"
                        locale="zh-cn"
                        @change="nv => item.startDate= nv"
                    />
                  </v-menu>
                </v-flex>

                <v-flex sm6>
                  <v-menu
                      ref="refReceiveEndDate"
                      :close-on-content-click="false"
                      v-model="menuReviewEndDate"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px">
                    <v-text-field
                        slot="activator"
                        v-model="item.endDate"
                        label="评审结束日期"
                        :rules="rules.endDate"
                        hint="格式YYYY-MM-DD"
                        persistent-hint
                    />
                    <v-date-picker
                        v-model="reviewEndDate"
                        locale="zh-cn"
                        @change="nv => item.endDate= nv"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm12>
                  <v-textarea
                      label="备注信息"
                      counter="200"
                      v-model="note"
                  />
                </v-flex>

              </v-layout>
            </v-container>
          </v-form>

        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat color="primary" @click.native="$emit('input', false)">取消</v-btn>
        <v-btn color="primary" :disabled="loading" @click.native="onSubmit">开启评审</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "StartReview",
  model: {
    prop: 'visable',
    event: 'input'
  },

  props: ['visable', 'message', 'uri', 'dbid', 'recenddate', 'expertCount'],
  data() {
    return {
      formStartValid: false,

      loading: false,
      note: '',

      item: {},

      reviewStartDate: '',
      menuReviewStartDate: false,

      reviewEndDate: '',
      menuReviewEndDate: false,

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误',
          v => (v && v > this.recenddate) || "评审开始日期必须大于或等于申报结束日期。"
        ],
        endDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。"
        ]
      }
    }
  },


  methods: {
    onSubmit() {
      if (this.$refs.formRef.validate()) {
        if (this.expertCount) {
          const vm = this;
          //vm.loading = true;
          //const param = window.xutil.param("note", this.note);
          const titem =
              {
                "note": this.note,
                "reviewStartDate": this.reviewStartDate,
                "reviewEndDate": this.reviewEndDate,
              }
          this.axios.put(`${this.uri}/review/${this.dbid}`, titem)
              .then(rsp => {
                vm.$emit('ok', rsp.data);
                vm.$emit('input', false);
                vm.$emit('reset', false);
                vm.loading = false;
              });
        }
        else
        {
          alert("在开启评审前请先为本次评审指定专家组！")
        }
      }
    }
  },
}
</script>

<style scoped>

</style>